import util from '../util'

let controller = 'ConsultaOperacional'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), { 
  RelatorioLimiteBoleto: function (dto) {
    return util.Axios.GetAll(controller + '/LimiteConsultaBoleto', dto)
  },
  ListarSolicitacoesRecusadas: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/SolicitacoesRecusadas', dto)
  }
})
